// Shared by the page and its skeleton, so loading and loaded rows line up.
export const KPI_ROW_CLASS = 'grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4';
export const PIE_ROW_CLASS = 'grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4';
export const PAIR_ROW_CLASS = 'grid grid-cols-1 gap-4 lg:grid-cols-2';
